import * as React from 'react';
import { ConfigProvider, Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import { RouteContent } from './routes';
import { SideMenu } from './components/SideMenu';
import { AppContextProvider } from './context/AppContext';

const { Content } = Layout;

const App = () => {
  // To be updated when BE endpoint is ready
  const location = useLocation();
  const hideSidebarOnPaths = ['/', '/login', '/create-password'];
  const shouldShowSidebar = !hideSidebarOnPaths.includes(location.pathname);

  return (
    <AppContextProvider>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#FF6F0B',
            colorPrimaryHover: '#FFF1E7',
            colorPrimaryBg: '#FFF1E7',
            controlItemBgHover: '#FFF1E7',
            colorLinkHover: '#FFF1E7',
            colorBgTextHover: '#FFF1E7',
            colorPrimaryBgHover: '#FFF1E7'
          },
          components: {
            Menu: {
              // colorPrimaryActive: '#FF6F0B',
              // colorPrimary: '#FF6F0B',
              // colorPrimaryBg: '#FF0000',
              // itemSelectedBg: '#FFF1E7',
              // itemSelectedColor: '#FF6F0B'
            },
            Button: {
              colorPrimaryHover: '#FFF1E7',
              colorBgTextHover: '#FFF1E7'
            },
            Modal: {
              titleFontSize: 24,
            },
            Input: {
              colorBorder: '#FF6F0B',
              colorPrimaryBorder: '#FF6F0B',
              colorPrimaryBorderHover: '#FF6F0B',
              colorPrimary: '#FF6F0B',
              colorIconHover: '#FF6F0B',
              colorInfoActive: '#FF6F0B',
              colorPrimaryBg: '#FF6F0B',
              colorPrimaryActive: '#FF6F0B',
              colorSuccessActive: '#FF6F0B',
            }
          },
        }}
      >
        <Layout style={{ minHeight: '100vh', backgroundColor: '#FFF2F2' }}>
          {shouldShowSidebar && <SideMenu />}
          <Layout
            className={`site-layout  ${
              shouldShowSidebar ? 'normal-layout' : ''
            }`}
          >
            <Content
              className={`${
                shouldShowSidebar ? 'content-layout px-20 py-12' : ''
              }`}
            >
              <RouteContent />
            </Content>
          </Layout>
        </Layout>
      </ConfigProvider>
    </AppContextProvider>
  );
};

export default App;
